var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSogukpinar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.4,23.1c-.4,1-1.3,1.8-2.1,1.5-5.3-1.7-9.7,1.7-14.6,2.5-1.5.2-3,.3-4.3,1-7,3.5-12.8.2-13.1-7.6,0-.6,0-1.1,0-1.7C-.9,8.2,1.2,5.9,12.6,5.7c3.4-.4,7.1.2,10,3.5,1.3,1.4,3.1,2,5,2.2,5.4.6,8.8,6.8,6.8,11.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSogukpinar);
export default __webpack_public_path__ + "static/media/sogukpinar.b07b27675e27dce13b694e3507d5a86e.svg";
export { ForwardRef as ReactComponent };